import styled from "styled-components";
import { ReactComponent as PointUp } from "../../assets/svgIcon/listView/Point.svg";
import { useRef, useState } from "react";
import { createPortal } from "react-dom";

export const ToolTip = ({ textOfTitle, position, styleOfTooltip, hover }) => {
  const classNameForTooltip = position === "right" ? "rightSide toolTip" : "toolTip";
  return (
    <ToolTipCss style={styleOfTooltip} className={classNameForTooltip} role="tooltip">
      <span className={position === "right" ? "pointUp rightSide" : "pointUp leftSide"}>
        <PointUp />{" "}
      </span>
      {textOfTitle}
    </ToolTipCss>
  );
};

export const ShowTextOnHover = ({ text = "", noOfChar, widthOfText }) => {
  const [isHover, setIsHover] = useState(false);
  const textRef = useRef(null);
  const isTextTrimmed = noOfChar
    ? text.length > noOfChar
    : textRef.current?.scrollWidth > textRef.current?.clientWidth;
  const displayText = noOfChar ? text.slice(0, noOfChar) + "..." : text;

  const position =
    textRef.current?.getBoundingClientRect().x > window.innerWidth / 2 ? "right" : "left";

  const styleOfParentDiv = isHover ? { position: "relative" } : {};
  if (widthOfText) {
    styleOfParentDiv["width"] = widthOfText;
    styleOfParentDiv["maxWidth"] = "max-content";
  }

  return (
    <div
      style={styleOfParentDiv}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div
        ref={textRef}
        style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
      >
        {displayText}
      </div>

      {isHover && isTextTrimmed && <ToolTip textOfTitle={text} position={position} />}
    </div>
  );
};

export const TextWithHover = ({ text = "--", noOfChar = 15 }) => {
  if (text.length > noOfChar + 1) {
    return <ShowTextOnHover text={text} noOfChar={noOfChar} />;
  }
  return text;
};

export const TextOnHoverWhenAdjust = ({ text = "--", widthOfElement, textAlign = "" }) => {
  return (
    <td>
      <div style={{ width: widthOfElement, textAlign }}>
        <ShowTextOnHover text={text || "--"} />
      </div>
    </td>
  );
};

export const toolTipFn = hover => {
  const styleOfTooltip = {
    top: `${hover?.rect.bottom + window.scrollY + 4}px`,
    left: `${hover?.rect.left + window.scrollX}px`,
  };

  return createPortal(
    <ToolTip textOfTitle={hover?.text} styleOfTooltip={styleOfTooltip} />,
    document.body,
  );
};

const ToolTipCss = styled.div`
  border-radius: 4px;
  background-color: var(--Dark-Grey, #262641);
  padding: 8px 16px;
  min-width: max-content;
  color: var(--Light---text-color-on-inverted, #fff);
  font-weight: 400;
  line-height: 20px;
  position: absolute;
  pointer-events: none;
  top: 32px;
  z-index: 111;
  a {
    color: var(--Light---text-color-on-inverted, #fff) !important;
    font-weight: 400 !important;
  }

  > .pointUp {
    position: absolute;
    top: -15px;
    z-index: 111;
  }
  .leftSide {
    left: 0;
  }
`;
